import {OutsideTemperatures} from '../shared';

export enum ChargeScenarios {
  atHome = 'atHome',
  atWork = 'atWork',
  atPublic = 'atPublic',
  atHighway = 'atHighway',
}

export enum ChargerTypeValues {
  socketAC = 'socketAC',
  wallboxAC = 'wallboxAC',
  stationDC = 'stationDC',
}

export type ChargeDelta = [StartSoc, FinalSoc] | undefined;
export type StartSoc = 0 | 10 | 20 | 30 | 40 | 50 | 60 | 70 | 80 | 90;
export type FinalSoc = 50 | 60 | 70 | 80 | 90 | 100;

export type ChargeTimeBatterySimulationDataSource =
  SourceChargeTimeScenarioEntry[];

export interface SourceChargeTimeScenarioEntry {
  scenario: ChargeScenarios;
  outsideTemperature: OutsideTemperatures;
  startSoc: StartSoc;
  finalSoc: FinalSoc;
  chargingOptions: SourceChargingOption[];
}

export interface SourceChargingOption {
  chargingType: 'AC' | 'DC';
  chargingSpeed: number;
  chargingDuration: number | null;
}

export type ChargingOption = [chargingSpeed: number, chargingDuration: number];
export type ChargingOptionV2 = {
  chargingSpeed: number;
  duration: {preHeated?: number; nonPreHeated?: number};
};

export interface ChargeTimeScenarioEntry {
  wallboxAC?: ChargingOption[];
  socketAC?: ChargingOption[];
  stationDC?: ChargingOption[];
}

export interface ChargeTimeScenarioEntryV2 {
  wallboxAC?: ChargingOptionV2[];
  socketAC?: ChargingOptionV2[];
  stationDC?: ChargingOptionV2[];
}
/**
 * This data is in a tree shape, as it had to be optimised for better data
 * efficiency while still allowing readability and easy access from the input
 * parameters.
 * Without the optimisation, the min zipped data was about twice as large.
 */
export interface ChargeTimeBatterySimulationData {
  startSocMax: number;
  finalSocMin: number;
  scenarios: {
    [s in ChargeScenarios]?: {
      outsideTemperature: {
        [t in OutsideTemperatures]?: {
          startSoc: {
            [st in StartSoc]?: {
              finalSoc: {
                [f in FinalSoc]?: ChargeTimeScenarioEntry;
              };
            };
          };
        };
      };
    };
  };
}

export interface ChargeTimeBatterySimulationDataV2 {
  startSocMax: number;
  finalSocMin: number;
  scenarios: {
    [s in ChargeScenarios]?: {
      outsideTemperature: {
        [t in OutsideTemperatures]?: {
          startSoc: {
            [st in StartSoc]?: {
              finalSoc: {
                [f in FinalSoc]?: ChargeTimeScenarioEntryV2;
              };
            };
          };
        };
      };
    };
  };
}
